/**
 * GMA-1617 (CompassCare Web) — placeholder for not-yet-built facelift sections.
 *
 * The Sidebar renders all 13 WEB_NAV_SECTIONS, but the facelift ships screen by
 * screen (GMA-1617 Overview first, then 1618+). Until a section's real screen
 * lands, its /web/<section> route renders this placeholder inside the shell — so
 * navigation never dead-ends on an unregistered route. Each real screen replaces
 * its placeholder as its story lands.
 */
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import { WEB_NAV_SECTIONS } from "./webNavModel";
import { theme } from "../../styles/designTokens";

export default function WebSectionPlaceholder() {
  const navigate = useNavigate();
  const { section } = useParams();
  const nav = WEB_NAV_SECTIONS.find((s) => s.key === section);

  return (
    <WebShell
      activeKey={nav ? nav.key : undefined}
      onNavigate={(target) => {
        if (target && target.path) navigate(target.path);
      }}
      title={nav ? nav.label : "CompassCare Web"}
    >
      <div style={{ padding: 24, color: theme.textMuted }}>
        <p data-testid="web-section-placeholder" style={{ margin: 0 }}>
          {nav ? `${nav.label} is coming soon.` : "This screen is coming soon."}
        </p>
      </div>
    </WebShell>
  );
}
